<form [formGroup]="form"
    [connectForm]="user">
    <div class="row mb-3">
        <div class="form-group col-md-6">
            <label for="givenNameId"
                class="form-label required">
                Given Name
            </label>

            <input id="givenNameId"
                class="form-control"
                formControlName="givenName"/>

            <div *ngIf="controls.givenName.touched && controls.givenName.errors?.required"
                class="alert alert-danger">
                Please enter a given name
            </div>
        </div>

        <div class="form-group col-md-6">
            <label for="lastNameId"
                class="form-label required">
                Family Name
            </label>

            <input id="lastNameId"
                class="form-control"
                formControlName="familyName"/>

            <div *ngIf="controls.familyName.touched && controls.familyName.errors?.required"
                class="alert alert-danger">
                Please enter a family name
            </div>
        </div>
    </div>

    <div class="row mb-3">
        <div class="form-group col-md-6">
            <label for="sfId"
                class="form-label">
                Salesforce ID
            </label>

            <input id="sfId"
                class="form-control"
                formControlName="sfId" />

            <div *ngIf="controls.sfId.touched && controls.sfId.errors"
                class="alert alert-danger">
                Min length: 18<br />
                Max length: 50
            </div>
        </div>

        <div class="form-group col-md-6">
            <label for="phoneNumberId"
                class="form-label">
                Phone Number
            </label>

            <input id="phoneNumberId"
                class="form-control"
                formControlName="phoneNumber"/>

            <div *ngIf="controls.phoneNumber.touched && controls.phoneNumber.errors"
                class="alert alert-danger">
                Please enter a valid phone number with extension
            </div>
        </div>

    </div>

    <div class="row mb-3">
        <div class="form-group col-md-6">
            <label for="jobTitleId"
                class="form-label">
                Job Title
            </label>

            <input id="jobTitleId"
                class="form-control"
                formControlName="jobTitle"/>
        </div>

        <div class="form-group col-md-6">
            <label 
                class="form-label">
                Job Location
            </label>

            <ng-select *ngIf="!isReadonly"
                id="jobLocId"
                labelForId="jobLocationId"
                [searchable]=true
                [items]="locations"
                [virtualScroll]="true"
                [bindLabel]="'name'"
                [bindValue]="'name'"
                [clearable]="false"
                formControlName="jobLocation">
            </ng-select>

            <input *ngIf="isReadonly"
                id="jobLocIdInput"
                class="form-control"
                formControlName="jobLocation"/>
        </div>
    </div>

    <div class="form-group mb-3">
        <label for="linkedInLink" class="form-label">
        LinkedIn Link
        </label>

        <input id="linkedInLink"
            class="form-control" autocomplete="off"
            formControlName="linkedInLink"/>
    </div>

    <div class="form-group mb-3">
        <label for="notes" class="form-label">
        Notes
        </label>

        <textarea id="notes"
            class="form-control" autocomplete="off"
            formControlName="notes" rows="2"></textarea>
    </div>

    <div *ngIf="isAddUser"
        class="form-group mb-3">
        <label for="emailId"
            class="form-label required">
            Email (Username)
        </label>

        <input id="emailId"
            name="email"
            type="email"
            class="form-control"
            formControlName="email"
            placeholder="you@example.com"/>

        <div *ngIf="controls.email.touched && controls.email.errors"
            class="alert alert-danger">
            Please enter a valid email address
        </div>
    </div>

    <div *ngIf="isAddUser"
        class="form-group mb-3">
        <label for="passwordId"
            class="form-label">
            Password - (Optional - System will generate a random password if not provided)
        </label>

        <input id="passwordId"
            class="form-control"
            formControlName="password"/>
    </div>

    <div *ngIf="isAddUser" class="form-group">
        <label for="suppressWelcomeEmail"
            class="form-label">
            Disable welcome email&nbsp;&nbsp;
        </label>

        <input id="suppressWelcomeEmail"
            type="checkbox"
            class="checkbox"
            formControlName="suppressWelcomeEmail"/>
    </div>
</form>
